/* ============================================
   AURAVO — SINGLE PRODUCT THEME JS v3.0
   Cart is always read from Shopify (/cart.js), so the drawer
   shows exactly what checkout will charge.
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  var CFG = window.AURAVO || { tiers: [], shipping: 0, freeThreshold: 0 };
  var TIERS = (CFG.tiers || []).filter(function (t) { return t && t.price > 0; });

  function rs(n) {
    n = Math.round(Number(n) || 0);
    return 'Rs. ' + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ---- CUSTOM CURSOR ---- */
  var cursor = document.getElementById('cursor');
  var cursorRing = document.getElementById('cursorRing');
  if (cursor && cursorRing && window.matchMedia('(pointer:fine)').matches) {
    var mx = 0, my = 0, rx = 0, ry = 0;
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      cursor.style.left = mx + 'px'; cursor.style.top = my + 'px';
    });
    (function animateRing() {
      rx += (mx - rx) * 0.12; ry += (my - ry) * 0.12;
      cursorRing.style.left = rx + 'px'; cursorRing.style.top = ry + 'px';
      requestAnimationFrame(animateRing);
    })();
  }

  /* ---- SESSION TIMER ---- */
  var timerSecs = 14 * 60 + 35;
  function updateTimer() {
    if (timerSecs <= 0) timerSecs = 14 * 60 + 35;
    var m = String(Math.floor(timerSecs / 60)).padStart(2, '0');
    var s = String(timerSecs % 60).padStart(2, '0');
    ['timerMin', 'heroTimerMin'].forEach(function (id) { var el = document.getElementById(id); if (el) el.textContent = m; });
    ['timerSec', 'heroTimerSec'].forEach(function (id) { var el = document.getElementById(id); if (el) el.textContent = s; });
    timerSecs--;
  }
  updateTimer();
  setInterval(updateTimer, 1000);

  /* ---- NAV SCROLL + STICKY BAR ---- */
  var nav = document.getElementById('mainNav');
  var stickyBar = document.getElementById('stickyBar');
  window.addEventListener('scroll', function () {
    if (nav) nav.classList.toggle('scrolled', window.scrollY > 40);
    if (stickyBar) stickyBar.classList.toggle('visible', window.scrollY > 700);
  });

  /* ---- MOBILE NAV ---- */
  window.toggleMobileNav = function () {
    var mn = document.getElementById('mobileNav');
    var ov = document.getElementById('mobileNavOverlay');
    if (!mn) return;
    var open = mn.classList.toggle('open');
    if (ov) ov.classList.toggle('open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  };

  /* ---- SCROLL ANIMATIONS ---- */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('visible'); });
    }, { threshold: 0.12 });
    document.querySelectorAll('.fade-up').forEach(function (el) { observer.observe(el); });
  } else {
    document.querySelectorAll('.fade-up').forEach(function (el) { el.classList.add('visible'); });
  }

  /* ---- PRODUCT IMAGE GALLERY ---- */
  window.setProductImg = function (el) {
    var src = el.getAttribute('data-src');
    if (!src) return;
    var mainImg = document.getElementById('mainProductImg');
    if (mainImg && mainImg.tagName === 'IMG') {
      mainImg.style.transition = 'opacity 0.2s';
      mainImg.style.opacity = '0';
      setTimeout(function () { mainImg.src = src; mainImg.style.opacity = '1'; }, 180);
    }
    document.querySelectorAll('.product-thumb').forEach(function (t) { t.classList.remove('active'); });
    el.classList.add('active');
  };

  /* ---- DESCRIPTION TOGGLE ---- */
  window.toggleDesc = function (el) {
    el.classList.toggle('open');
    var body = el.nextElementSibling;
    if (body) body.classList.toggle('open');
  };

  /* ---- SCROLL TO BUY BOX ---- */
  window.scrollToProduct = function () {
    var el = document.getElementById('product');
    if (el) { el.scrollIntoView({ behavior: 'smooth' }); }
    else { window.location.href = '/#product'; }
  };

  /* ---- REVIEW "READ MORE" ---- */
  document.querySelectorAll('.review-card__text').forEach(function (el) {
    if (el.textContent.length > 260) {
      el.classList.add('clamped');
      var btn = document.createElement('button');
      btn.className = 'review-card__more';
      btn.type = 'button';
      btn.textContent = 'Read more';
      btn.addEventListener('click', function () {
        var c = el.classList.toggle('clamped');
        btn.textContent = c ? 'Read more' : 'Show less';
      });
      el.parentNode.insertBefore(btn, el.nextSibling);
    }
  });

  /* ================================================================
     PRICING TIERS (buy box)
  ================================================================ */
  var selected = TIERS[TIERS.length - 1];

  function tierByN(n) {
    for (var i = 0; i < TIERS.length; i++) if (TIERS[i].n === n) return TIERS[i];
    return TIERS[0];
  }

  function renderTiers() {
    var box = document.getElementById('pricingOptions');
    if (!box) return;
    if (!TIERS.length) {
      box.innerHTML = '<div class="pricing-loading">Set prices in Theme settings › Main product &amp; pricing.</div>';
      return;
    }
    var badges = { 1: null, 2: 'MOST POPULAR', 3: 'BEST OFFER' };
    box.innerHTML = TIERS.map(function (t) {
      var saved = t.compare > t.price ? t.compare - t.price : 0;
      var pct = t.compare > t.price ? Math.round((1 - t.price / t.compare) * 100) : 0;
      if (pct < 5) pct = 0;
      var free = CFG.freeThreshold > 0 && t.price >= CFG.freeThreshold;
      var isSel = selected && selected.n === t.n;
      var badge = badges[t.n];
      return '<div class="pricing-option' + (isSel ? ' selected' : '') + (t.available ? '' : ' soldout') + '" data-n="' + t.n + '" onclick="selectBundle(' + t.n + ')" role="radio" aria-checked="' + isSel + '" tabindex="0">' +
        (badge ? '<div class="pricing-badge' + (t.n === 3 ? ' pricing-badge--gold' : '') + '">' + badge + '</div>' : '') +
        (saved ? '<div class="pricing-save-tag">You Save ' + rs(saved) + '</div>' : '') +
        '<div class="pricing-option__radio"></div>' +
        '<div style="flex:1;padding-top:6px;">' +
          '<div class="pricing-option__qty">Buy ' + t.n + ' Belt' + (t.n > 1 ? 's' : '') + (pct ? ' <span class="pricing-pct">' + pct + '% OFF</span>' : '') + '</div>' +
          '<div class="pricing-option__label">' + (t.available ? (t.label || '') : 'Sold out') + '</div>' +
        '</div>' +
        '<div style="text-align:right;padding-top:6px;">' +
          (t.compare > t.price ? '<div class="pricing-option__compare">' + rs(t.compare) + '</div>' : '') +
          '<div class="pricing-option__price">' + rs(t.price) + '</div>' +
          '<span class="pricing-save">' + (free ? 'FREE Shipping ✓' : (CFG.shipping ? '+ ' + rs(CFG.shipping) + ' shipping' : 'COD Available')) + '</span>' +
        '</div>' +
      '</div>';
    }).join('');
    updateSelectedUI();
  }

  function updateSelectedUI() {
    if (!selected) return;
    var priceEl = document.getElementById('selectedPrice');
    if (priceEl) priceEl.textContent = rs(selected.price);
    var note = document.getElementById('shippingNote');
    if (note) {
      if (CFG.freeThreshold > 0 && selected.price >= CFG.freeThreshold) note.textContent = '🎉 FREE shipping on this pack · Cash on Delivery available';
      else if (CFG.shipping) note.textContent = rs(CFG.shipping) + ' shipping' + (CFG.freeThreshold ? ' · FREE over ' + rs(CFG.freeThreshold) : '') + ' · Cash on Delivery';
      else note.textContent = 'Cash on Delivery available all over Pakistan';
    }
    var sp = document.getElementById('stickyBarPrice');
    if (sp) sp.textContent = 'From ' + rs(TIERS[0].price) + ' · COD All Pakistan';
    var btn = document.getElementById('addToCartBtn');
    if (btn) btn.disabled = !selected.available;
  }

  window.selectBundle = function (n) {
    selected = tierByN(n);
    document.querySelectorAll('.pricing-option').forEach(function (el) {
      var on = Number(el.getAttribute('data-n')) === n;
      el.classList.toggle('selected', on);
      el.setAttribute('aria-checked', on);
    });
    updateSelectedUI();
  };
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if ((e.key === 'Enter' || e.key === ' ') && t.classList && t.classList.contains('pricing-option')) {
      e.preventDefault(); selectBundle(Number(t.getAttribute('data-n')));
    }
  });

  renderTiers();

  /* ================================================================
     SHOPIFY CART
  ================================================================ */
  function addSelected() {
    if (!selected || !selected.variantId) {
      return Promise.reject(new Error('No variant — select the main product in Theme settings.'));
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: selected.variantId, quantity: selected.qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
      return r.json();
    });
  }

  window.addToCart = function () {
    var btn = document.getElementById('addToCartBtn');
    if (btn) { btn.classList.add('adding'); btn.disabled = true; }
    addSelected()
      .then(function () {
        showToast('✿ Added to cart!', (CFG.title || 'Relief Belt') + ' × ' + selected.n + ' — ' + rs(selected.price));
        return refreshCart();
      })
      .then(function () { openCart(); })
      .catch(function (err) { showToast('Could not add', err.message); })
      .then(function () { if (btn) { btn.classList.remove('adding'); btn.disabled = false; } });
  };

  window.buyNow = function () {
    fetch('/cart/clear.js', { method: 'POST' })
      .then(addSelected)
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (err) { showToast('Could not continue', err.message); });
  };

  window.stickyOrder = function () {
    if (document.getElementById('pricingOptions')) { scrollToProduct(); return; }
    window.location.href = '/#product';
  };

  /* compare-at lookup by variant id */
  function compareFor(item) {
    for (var i = 0; i < TIERS.length; i++) {
      var t = TIERS[i];
      if (t.variantId === item.variant_id) {
        if (CFG.bundleVariants) return t.compare * item.quantity;
        return (TIERS[0].compare || 0) * item.quantity;
      }
    }
    return item.original_line_price / 100;
  }

  function renderCart(cart) {
    var body = document.getElementById('cartBody');
    var footer = document.getElementById('cartFooter');
    var count = cart.item_count || 0;
    ['cartCount', 'cartCountMobile'].forEach(function (id) { var el = document.getElementById(id); if (el) el.textContent = count; });

    if (!body) return;
    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<div class="cart-empty">Your cart is empty.<br><button class="cart-empty__btn" onclick="closeCart();scrollToProduct();">Shop the Relief Belt →</button></div>';
      if (footer) footer.style.display = 'none';
      return;
    }
    if (footer) footer.style.display = 'block';

    var total = cart.total_price / 100;
    var origTotal = 0;

    body.innerHTML = cart.items.map(function (item, idx) {
      var line = item.final_line_price / 100;
      var cmp = Math.max(compareFor(item), line);
      origTotal += cmp;
      var img = item.image ? '<img class="cart-item__img" src="' + item.image + '" alt="">' : '<div class="cart-item__img cart-item__img--ph">✿</div>';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      return '<div class="cart-item">' + img +
        '<div class="cart-item__info">' +
          '<div class="cart-item__name">' + item.product_title + '</div>' +
          (variant ? '<div class="cart-item__variant">' + variant + '</div>' : '') +
          (cmp > line ? '<div class="cart-item__save">Save ' + rs(cmp - line) + '</div>' : '') +
          '<div class="cart-item__row">' +
            '<div class="cart-item__qty-ctrl">' +
              '<button class="cart-qty-btn" onclick="changeCartLine(' + (idx + 1) + ',' + (item.quantity - 1) + ')" aria-label="Decrease">−</button>' +
              '<div class="cart-qty-num">' + item.quantity + '</div>' +
              '<button class="cart-qty-btn" onclick="changeCartLine(' + (idx + 1) + ',' + (item.quantity + 1) + ')" aria-label="Increase">+</button>' +
            '</div>' +
            '<div style="text-align:right;">' +
              (cmp > line ? '<div class="cart-item__compare">' + rs(cmp) + '</div>' : '') +
              '<div class="cart-item__price">' + rs(line) + '</div>' +
            '</div>' +
          '</div>' +
        '</div></div>';
    }).join('');

    var totalEl = document.getElementById('cartTotal');
    if (totalEl) totalEl.innerHTML = (origTotal > total ? '<span class="cart-subtotal__compare">' + rs(origTotal) + '</span>' : '') + rs(total);

    var thr = CFG.freeThreshold || 0;
    var free = thr > 0 && total >= thr;
    var fill = document.getElementById('progressFill');
    var label = document.getElementById('progressLabel');
    var ship = document.getElementById('cartShipping');
    var wrap = fill ? fill.parentNode : null;
    if (thr > 0) {
      if (wrap) wrap.style.display = '';
      if (fill) fill.style.width = Math.min(total / thr * 100, 100) + '%';
      if (label) label.textContent = free ? '🎉 Free shipping unlocked!' : 'Add ' + rs(thr - total) + ' more for FREE shipping';
    } else {
      if (wrap) wrap.style.display = 'none';
      if (label) label.textContent = '';
    }
    if (ship) ship.textContent = free ? 'FREE shipping · Cash on Delivery' : (CFG.shipping ? 'Shipping calculated at checkout · COD available' : 'Cash on Delivery available');
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () {});
  }

  window.changeCartLine = function (line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(refreshCart);
  };

  window.openCart = function () {
    var ov = document.getElementById('cartOverlay');
    var dr = document.getElementById('cartDrawer');
    if (ov) ov.classList.add('open');
    if (dr) dr.classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  window.closeCart = function () {
    var ov = document.getElementById('cartOverlay');
    var dr = document.getElementById('cartDrawer');
    if (ov) ov.classList.remove('open');
    if (dr) dr.classList.remove('open');
    document.body.style.overflow = '';
  };
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  /* ---- TOAST ---- */
  var toastTimer;
  window.showToast = function (msg, sub) {
    var t = document.getElementById('toast');
    var mEl = document.getElementById('toastMsg');
    var sEl = document.getElementById('toastSub');
    if (!t) return;
    if (mEl) mEl.textContent = msg;
    if (sEl) sEl.textContent = sub || '';
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 4000);
  };

  /* clear legacy fake-cart storage from the old theme */
  try { localStorage.removeItem('hg_cart'); } catch (e) {}

  refreshCart();
});

/* ---- Always open the page at the top (hero), unless the link has a #section ---- */
if ('scrollRestoration' in history) { history.scrollRestoration = 'manual'; }
window.addEventListener('load', function () {
  if (!location.hash) { window.scrollTo(0, 0); }
});

/* ===== AURAVO: mobile gallery + zoom + photos below buy box ===== */
document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.gallery-stack')) return; /* already added */
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.product-thumb'));
  var mainImg = document.getElementById('mainProductImg');
  var grid = document.querySelector('.product-grid');
  if (!grid || !mainImg || mainImg.tagName !== 'IMG') return;
  var srcs = thumbs.map(function (t) { return t.getAttribute('data-src'); }).filter(Boolean);
  if (!srcs.length) srcs = [mainImg.src];
  var current = 0;

  /* Zoom viewer */
  var lb = document.createElement('div');
  lb.className = 'lb';
  lb.innerHTML = '<button class="lb__close" aria-label="Close">✕</button>' +
    '<button class="lb__nav lb__prev" aria-label="Previous">‹</button>' +
    '<img class="lb__img" alt="">' +
    '<button class="lb__nav lb__next" aria-label="Next">›</button>' +
    '<div class="lb__count"></div>';
  document.body.appendChild(lb);
  var lbImg = lb.querySelector('.lb__img'), lbCount = lb.querySelector('.lb__count');
  if (srcs.length < 2) lb.querySelectorAll('.lb__nav').forEach(function (b) { b.style.display = 'none'; });

  function show(i) {
    current = (i + srcs.length) % srcs.length;
    lbImg.src = srcs[current];
    lbCount.textContent = (current + 1) + ' / ' + srcs.length;
  }
  function openLb(i) { show(i); lb.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeLb() { lb.classList.remove('open'); document.body.style.overflow = ''; }
  lb.querySelector('.lb__close').addEventListener('click', closeLb);
  lb.querySelector('.lb__prev').addEventListener('click', function () { show(current - 1); });
  lb.querySelector('.lb__next').addEventListener('click', function () { show(current + 1); });
  lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
  document.addEventListener('keydown', function (e) {
    if (!lb.classList.contains('open')) return;
    if (e.key === 'Escape') closeLb();
    if (e.key === 'ArrowLeft') show(current - 1);
    if (e.key === 'ArrowRight') show(current + 1);
  });

  function addSwipe(el, onLeft, onRight) {
    var x0 = null, y0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { if (dx < 0) onLeft(); else onRight(); }
      x0 = null;
    }, { passive: true });
  }
  addSwipe(lb, function () { show(current + 1); }, function () { show(current - 1); });

  /* Main image: tap = zoom, swipe = next/previous photo */
  var main = 0;
  var wrap = mainImg.parentNode;
  wrap.classList.add('zoomable');
  var hint = document.createElement('div');
  hint.className = 'zoom-hint';
  hint.textContent = '🔍 Tap to zoom';
  wrap.appendChild(hint);
  var dots = document.createElement('div');
  dots.className = 'main-dots';
  if (srcs.length > 1) dots.innerHTML = srcs.map(function (_, i) { return '<span' + (i === 0 ? ' class="on"' : '') + '></span>'; }).join('');
  wrap.appendChild(dots);

  function setMain(i) {
    main = (i + srcs.length) % srcs.length;
    if (thumbs[main] && window.setProductImg) window.setProductImg(thumbs[main]);
    else mainImg.src = srcs[main];
    dots.querySelectorAll('span').forEach(function (d, k) { d.classList.toggle('on', k === main); });
  }
  thumbs.forEach(function (t, i) { t.addEventListener('click', function () { main = i; dots.querySelectorAll('span').forEach(function (d, k) { d.classList.toggle('on', k === i); }); }); });
  mainImg.addEventListener('click', function () { openLb(main); });
  addSwipe(mainImg, function () { setMain(main + 1); }, function () { setMain(main - 1); });

  /* All photos one by one below the buy section */
  if (srcs.length > 1) {
    var stack = document.createElement('div');
    stack.className = 'gallery-stack';
    stack.innerHTML = '<div class="gallery-stack__title">Product Photos</div>' +
      srcs.map(function (s, i) { return '<img class="gallery-stack__img" src="' + s + '" alt="Product photo ' + (i + 1) + '" loading="lazy" data-i="' + i + '">'; }).join('');
    grid.parentNode.insertBefore(stack, grid.nextSibling);
    stack.addEventListener('click', function (e) {
      var i = e.target.getAttribute('data-i');
      if (i !== null) openLb(Number(i));
    });
  }
});